import { extend, $, $$ } from './HelperFunctions'

export class SearchLayer {
  constructor (selectors, classes) {
    this.selectors = extend({
      searchOpen: '[data-js-search-open]',
      searchClose: '[data-js-search-close]',
      searchLayer: '[data-js-search-layer]'
    }, selectors)
    this.classes = extend({
      searchLayerOpened: 'search-layer--opened'
    }, classes)
  }

  init () {
    this.initSearchToggle()
  }

  initSearchToggle () {
    const that = this
    const searchOpen = $(that.selectors.searchOpen)
    const searchClose = $(that.selectors.searchClose)
    const searchLayer = $(that.selectors.searchLayer)
    if (searchOpen && searchOpen) {
      searchOpen.addEventListener('click', function () {
        searchLayer.classList.add(that.classes.searchLayerOpened)
        $('input', searchLayer).focus()

        that.initFocusManagement()
      })

      if (searchClose) {
        searchClose.addEventListener('click', function () {
          searchLayer.classList.remove(that.classes.searchLayerOpened)
          searchOpen.focus()
        })
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && searchLayer.classList.contains(that.classes.searchLayerOpened)) {
          searchLayer.classList.remove(that.classes.searchLayerOpened)
          searchOpen.focus()
        }
      })
    }
  }

  initFocusManagement () {
    const that = this
    const searchLayer = $(that.selectors.searchLayer)
    if (searchLayer) {
      searchLayer.addEventListener('keydown', function (event) {
        const focusableElements = $$('a, button, input', searchLayer)
        const firstFocusableElement = focusableElements[0]
        const lastFocusableElement = focusableElements[focusableElements.length - 1]

        function handleBackwardTab () {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault()
            lastFocusableElement.focus()
          }
        }

        function handleForwardTab () {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault()
            firstFocusableElement.focus()
          }
        }

        switch (event.key) {
          case 'Tab':
            if (event.shiftKey) {
              handleBackwardTab()
            } else {
              handleForwardTab()
            }
            break
          default:
            break
        }
      })
    }
  }
}

export default SearchLayer
